import { render, staticRenderFns } from "./BangkokOfficerManage.vue?vue&type=template&id=64d3bf10&"
import script from "./BangkokOfficerManage.vue?vue&type=script&lang=js&"
export * from "./BangkokOfficerManage.vue?vue&type=script&lang=js&"
import style0 from "./BangkokOfficerManage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports